module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAgElEQVRoge3WQQqAMAxE0cRFl3rv3sBj1guMCxGkoCiosfLfrrsJoWHMAAD4C0lJUpZU9D1FS7Z0NEAODnlG3mb2aoBiZv0z+73N5O7D+ugik9yhHmAMSXHNfka1/okBIJZaP6OiC72CLhSNLgQAD1HrZ1R0oVfQhaLRhQAA+IwZ+Ajge8x8ofMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = 70
// module chunks = 1